import { updateUserConfigurationAndService } from 'owa-session-store';
import { logUsage } from 'owa-analytics';

const VIEW_STATE_CONFIGURATION = 'OWA.ViewStateConfiguration';

export function setPreferredActionForCloudFile(action: number) {
    logUsage('AFPSetUserPrefferdAction', [action]);
    updateUserConfigurationAndService(
        configuration => {
            configuration.ViewStateConfiguration.AttachOrShareCloudFiles = action;
        },
        [
            {
                key: 'AttachOrShareCloudFiles',
                valuetype: 'Integer32',
                value: [`${action}`],
            },
        ],
        VIEW_STATE_CONFIGURATION
    );
}

export function setPreferredActionForGroupsFile(action: number) {
    logUsage('AFPSetUserPreferredActionGroups', [action]);
    updateUserConfigurationAndService(
        configuration => {
            configuration.ViewStateConfiguration.AttachOrShareGroupsFiles = action;
        },
        [
            {
                key: 'AttachOrShareGroupsFiles',
                valuetype: 'Integer32',
                value: [`${action}`],
            },
        ],
        VIEW_STATE_CONFIGURATION
    );
}
